import { eTipoPermissao } from '@/enums/ePermissoes';
import Index from '@/views/biblioteca/bibexemplar/Index.vue';
import CadastroComGrid from '@/views/biblioteca/bibexemplar/CadastroComGrid.vue';
export default [
    {
        description: 'Pesquisa Documento Escola',
        path: '/biblioteca/bibexemplar/1',
        name: 'bibexemplarescola',
        component: Index,
        meta: {
            permissions: [eTipoPermissao.BIB_EXEMPLARESCOLANOVO_MENU_1300100299],
        },
        goesToMenu: true,
    },
    {
        description: 'Pesquisa Documento Central',
        path: '/biblioteca/bibexemplar/0',
        name: 'bibexemplarcentral',
        component: Index,
        meta: {
            permissions: [eTipoPermissao.BIB_EXEMPLARCENTRALNOVO_MENU_1300100399],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Exemplar Escola',
        path: '/biblioteca/bibexemplar/cadastro/1/:bibDocumentoId',
        parent: 'bibexemplarcentral',
        name: 'bibexemplar_grid_escola',
        component: CadastroComGrid,
        meta: {
            permissions: [eTipoPermissao.BIB_EXEMPLARESCOLANOVO_MENU_1300100299],
        },
        goesToMenu: false,
    },
    {
        description: 'Cadastro de Exemplar Central',
        path: '/biblioteca/bibexemplar/cadastro/0/:bibDocumentoId',
        parent: 'bibexemplarcentral',
        name: 'bibexemplar_grid_central',
        component: CadastroComGrid,
        meta: {
            permissions: [eTipoPermissao.BIB_EXEMPLARCENTRALNOVO_MENU_1300100399],
        },
        goesToMenu: false,
    },
        {
        description: 'Cadastro de Exemplar Central',
        path: '/biblioteca/bibexemplar/cadastroexemplar/0/:id?',
        parent: 'bibexemplarcentral',
        name: 'bibexemplar_create_central',
        component: CadastroComGrid,
        meta: {
            permissions: [eTipoPermissao.BIB_EXEMPLARCENTRALNOVO_MENU_1300100399],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Exemplar Escola',
        path: '/biblioteca/bibexemplar/cadastroexemplar/1/:id?',
        parent: 'bibexemplarcentral',
        name: 'bibexemplar_create_escola',
        component: CadastroComGrid,
        meta: {
            permissions: [eTipoPermissao.BIB_EXEMPLARESCOLANOVO_MENU_1300100299],
        },
        goesToMenu: true,
    },


]
